import { render, staticRenderFns } from "./CampaignReports.vue?vue&type=template&id=22f21d46&"
import script from "./CampaignReports.vue?vue&type=script&lang=js&"
export * from "./CampaignReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports